import { useContext } from 'react';
import UpgradeButton from 'components/upgradeButton';
import ProfileContext from 'services/profileContext';
import { isAdmin } from 'utils/utils';
import styles from 'styles/components/upgradeRequired.module.scss';
import { Button } from 'antd';
import { logout } from 'services/api/users';
import { useNavigate } from 'react-router-dom';

const UpgradeRequired = () => {
  const { profile, clearProfile } = useContext(ProfileContext);
  const navigate = useNavigate();
  const admin = isAdmin(profile);

  return (
    <div className={styles.wrapper}>
      <div style={{ position: 'fixed', right: 0, top: 40, zIndex: 1000 }}>
        <Button type='link' onClick={() => {
          logout(() => {
            navigate('/login');
            clearProfile();
          });
        }}>Logout</Button></div>
      <div className={styles.card}>
        <h1 className={styles.title}>Upgrade required</h1>
        <p className={styles.message}>
          {admin
            ? 'Your free trial has expired. Upgrade now to continue using the app.'
            : 'Your free trial has expired. Please contact your workspace admin to upgrade and continue using the app.'}
        </p>
        {admin && (
          <div className={styles.actions}>
            <UpgradeButton style={{ padding: '8px 24px', height: 'auto' }} />
          </div>
        )}
      </div>
    </div>
  );
};

export default UpgradeRequired;
